import { render, staticRenderFns } from "./submitInfo.vue?vue&type=template&id=1112f9ab&scoped=true"
import script from "./submitInfo.vue?vue&type=script&lang=js"
export * from "./submitInfo.vue?vue&type=script&lang=js"
import style0 from "./submitInfo.vue?vue&type=style&index=0&id=1112f9ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1112f9ab",
  null
  
)

export default component.exports